import { getUserFromExternalAdmin } from '../../services/identity'
import type { ProductEnabledDate } from '../../services/pendo-integration/models'
import type { ShellHook } from './models'

export const initializeExternalAdmin: ShellHook = async shell => {
  const authContext = shell.getAuthContext()
  performance.mark('externalAdminFetches start')
  if (authContext.userProfile?.id) {
    const productEnabledDates = await getUserFromExternalAdmin(authContext.userProfile.id).then(({ settings = {} }) =>
      Object.entries(settings as ProductEnabledDate).map(([key, value]) => ({
        productName: key,
        enabledDate: value.enabledDate ? new Date(value.enabledDate as number) : undefined,
      })),
    )
    authContext.productEnabledDates = productEnabledDates
  }
  performance.measure('shell_externalAdminFetches', 'externalAdminFetches start')
}
